import { Div } from "./Div";
import { Tag } from "./Tag";

export class Table extends Div {

    public getTagName(): string {
        return "table";
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("table");
    }

    protected createSelf() {
        super.createSelf();
        const h: any[] = this.get("h");
        const b = this.get("b");
        const element: HTMLTableElement = this.getElement();
        if (h) {
            const trh: HTMLTableSectionElement = element.createTHead();
            const hr = trh.insertRow(0);
            h.forEach((i) => {
                const c = document.createElement("th");
                c.appendChild(document.createTextNode(i));
                hr.appendChild(c);
            });
        }

        if (b) {
            const trb: HTMLTableSectionElement = element.createTBody();
            b.forEach((r: any[]) => {
                const br = trb.insertRow(-1);
                r.forEach((i) => {
                    const cell = br.insertCell(-1);
                    if (i instanceof Object) {
                        const i2: Tag = new Tag(i);
                        cell.appendChild(i2.getElement());
                    } else {
                        cell.innerHTML = i;
                    }
                });
                this.appendChild(trb);
            });
        }
    }
}
